import type { SectionItem } from '@/types/components/section-item'

export const BUSINESS_SECTION_ITEMS: SectionItem[] = [
	{
		id: 'business-1',
		orangeTitleFirst: true,
		viewbox: {
			width: 405,
			height: 405
		},
		image: {
			url: '/images/worker-on-laptop.webp',
			alt: 'Maverix Fiber-fast internet'
		},
		lines: [
			{
				rotation: -15,
				length: 150,
				direction: 'counter-clockwise'
			}
		],
		circles: [
			{
				cx: 327,
				cy: 76,
				r: 61,
				fill: '#01629E'
			},
			{
				cx: 377.5,
				cy: 88,
				r: 21,
				fill: '#FF8A02'
			}
		]
	}
]
